import api from "api"

const retryUntil = (func, interval, retries, ...args) => {
  return new Promise(function(resolve) {
    const timer = setInterval(async () => {
      await func(clearTimer, ...args)
    }, interval)
    const clearTimer = () => clearInterval(timer)
    if (retries > 0) {
      setTimeout(function() {
        clearInterval(timer)
        resolve()
      }, interval * retries)
    }
  })
}

export async function loadScenarioProposalStatuses(store, scenario_id) {
  const proposalStatuses = await api.get(`scenarios/${scenario_id}/proposals`)
  await store.update(state => {
    state.scenarioProposalIds[scenario_id] = proposalStatuses.map(
      proposalStatus => proposalStatus.id
    )
    proposalStatuses.forEach(proposalStatus => {
      state.proposalStatuses[proposalStatus.id] = proposalStatus
    })
  })
}

export async function loadProposal(store, proposal_id) {
  const proposal = await api.get(`proposals/${proposal_id}`)
  await store.update(state => {
    state.proposals[proposal.id] = proposal
  })
}

export async function requestProposal(store, scenario_id, settings = {}) {
  let proposal = {}
  try {
    proposal = await api.post(
      `scenarios/${scenario_id}/proposals`,
      undefined,
      settings
    )
    if (process.env.REACT_APP_DEPLOY_ENV !== "production") {
      console.log("scenario_id = ", proposal["scenario_id"])
      console.log("proposal_id = ", proposal["id"])
    }
  } catch (error) {
    if (error.status === 409) {
      return error
    }
  }

  await store.update(state => {
    state.scenarioProposalIds[scenario_id].push(proposal.id)
    state.proposalStatuses[proposal.id] = proposal
    state.latestProposalState[scenario_id] = proposal
  })

  const checkProposalStatus = async clearRetry => {
    try {
      await store.actions.loadProposalStatus(proposal.id)
      const { status } = store.getState("latestProposalState", scenario_id)

      if (["ready", "unsuccessful"].includes(status)) {
        clearRetry()
      }
    } catch (error) {
      clearRetry()
      return
    }
  }

  retryUntil(checkProposalStatus, 1000, 10)
    .then(() => retryUntil(checkProposalStatus, 5000, 10))
    .then(() => retryUntil(checkProposalStatus, 10000, 10))
    .then(() => retryUntil(checkProposalStatus, 20000, 10))
    .then(() => retryUntil(checkProposalStatus, 30000, 10))
    .then(() => retryUntil(checkProposalStatus, 60000, -1))
}

export async function loadProposalStatus(store, proposal_id) {
  if (proposal_id) {
    let proposalStatus = await api.get(`proposals/${proposal_id}/status`)
    await store.update(state => {
      state.proposalStatuses[proposalStatus.id] = proposalStatus
      state.latestProposalState[proposalStatus.scenario_id] = proposalStatus
    })
  }
}
export async function loadLatestProposalState(store, scenarioId) {
  await store.actions.loadScenarioProposalStatuses(scenarioId)
  let proposalIds = store.getState("scenarioProposalIds", scenarioId)
  if (proposalIds && proposalIds.length > 0) {
    let proposalStatuses = proposalIds.map(id =>
      store.getState("proposalStatuses", id)
    )
    proposalStatuses.sort((a, b) =>
      new Date(a.requested_at) < new Date(b.requested_at) ? 1 : -1
    )
    let proposalStatus = store.getState(
      "proposalStatuses",
      proposalStatuses[0].id
    )
    await store.update(state => {
      state.latestProposalState[scenarioId] = proposalStatus
    })
  } else {
    await store.update(state => {
      state.latestProposalState[scenarioId] = {}
    })
  }
}

export async function approveProposal(store, proposal_id) {
  await api.post(`proposals/${proposal_id}/approve?notify`, undefined, {})
  await store.actions.loadProposalStatus(proposal_id)
  await store.actions.setCurrentHouseholdId(null)
}
